// eslint-disable-next-line no-shadow
enum ExportType {
  XSLX = 'XLSX',
  CSV = 'CSV',
  XML = 'XML',
  ALL = 'ALL',
  REPORT = 'REPORT',
}

type Export = 'XLSX' | 'CSV' | 'XML' | 'ALL' | 'REPORT';

export { Export, ExportType };
